import { ResponseError } from '../../errors';
import { IApplicationContext } from '../../types/applicationContext';
import { fetchGetMeta, TGetMetaRequest, TGetMetaResponse } from 'shared/repositories/search-offers-index/v2/get-meta';
import { ISearchMeta } from 'shared/types/searchMeta';

export async function fetchSearchMeta(
  { httpApi, logger, telemetry }: IApplicationContext,
  parameters: TGetMetaRequest,
): Promise<ISearchMeta | null> {
  const startTime = Date.now();

  try {
    telemetry.increment('meta.request');

    const searchMeta: TGetMetaResponse = await fetchGetMeta({
      httpApi,
      parameters,
    });

    if (searchMeta.statusCode !== 200) {
      throw new ResponseError({
        domain: 'critical.meta',
        message: searchMeta.response.message || '',
        details: {
          error: JSON.stringify(searchMeta.response.errors),
        },
      });
    }

    telemetry.increment('meta.response.success');

    return searchMeta.response.data;
  } catch (e) {
    telemetry.increment('meta.response.error');

    logger.warning(
      { ...e, domain: 'critical.meta' },
      {
        degradation: 'Запрос меты',
        details: {
          microserviceName: 'search-offers-index',
          pathApi: '/public/v2/get-meta/',
          parameters: JSON.stringify(parameters),
        },
      },
    );

    return null;
  } finally {
    telemetry.timing('meta.responseTime', Date.now() - startTime);
  }
}
